module.exports = __webpack_public_path__ + "static/media/add_circle-24px.fbe4ad2a.svg";